import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { matchRouteComponent } from './lazyRoutes';
import { loadPostContent, postFilenameForPath } from './data/postContentLoader';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

const render = () => {
  // Pages are pre-rendered at build time: use hydrate when pre-rendered HTML exists
  if (rootElement.hasChildNodes()) {
    ReactDOM.hydrate(app, rootElement);
  } else {
    ReactDOM.render(app, rootElement);
  }
};

// Preload the chunk for the current route before hydrating so the lazy
// component resolves synchronously on first render, avoiding a Suspense
// fallback flash that would discard the pre-rendered markup.
const isPrerendered = rootElement.hasChildNodes();
const initialRouteComponent = isPrerendered
  ? matchRouteComponent(window.location.pathname)
  : null;

const pending = [];
if (initialRouteComponent) {
  pending.push(initialRouteComponent.preload());
}

// A blog post's markdown is a separate chunk from the PostPage component, so
// the route chunk resolving is not enough. Hydrating before the markdown
// arrives replaces the prerendered article with an empty one and then re-expands
// it, moving everything below — the largest layout shift on every post page.
if (isPrerendered) {
  const postFilename = postFilenameForPath(window.location.pathname);
  if (postFilename) {
    pending.push(loadPostContent(postFilename));
  }
}

if (pending.length) {
  Promise.all(pending).then(render, render);
} else {
  render();
}
